import React from 'react'

const Breadchrumb = ({pageName}) => {
  return (
      <div className="about-hero">
        {/* <div className="overlay"></div> */}
        <div className="about-hero-content">
           <h1> <span>{pageName}</span></h1>
          <h3>Home  / <span>{pageName}</span></h3>
        </div>
      </div>
  )
}

export default Breadchrumb